import React from 'react';
import Paper from '@mui/material/Paper';
import Typography from '@mui/material/Typography';

const Footer = () => {
  return (
    <Paper
      square
      elevation={4}
      style={{
        position: 'fixed',
        bottom: 0,
        left: 0,
        width: '100%',
        padding: '10px',
        textAlign: 'center',
      }}
    >
      <Typography variant="body2" color="blue">
        Desarrollo WEB: nicolasmaurizi@gmail.com
      </Typography>
      
    </Paper>
  );
};

export default Footer;
